import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/planTorresConstants';

import { getRoundTower } from './planTorresSelectors';
import { getCurriculum, transformCurriculumItems } from '../../lib/PlanTorresCurriculumManager';

const initialState = {
  // true, if user was redirected to onboarding automatically
  isAutoOnboarding: false,
  // current step index
  currentStepIndex: null,
  // array with standard items for onboarding
  standardItems: [],
  // array with target words
  tower: [],
  // level index user selected before got auto-navigated to onboarding
  levelIndex: null,
};

const planTorresOnboardingRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ONBOARDING_ROUND: {
      const { isAutoOnboarding, levelIndex } = action.payload;
      const onboardingItems = getCurriculum().onboarding.standardItems;
      const onboardingItemsFinal = transformCurriculumItems(onboardingItems);

      return {
        ...initialState,
        standardItems: onboardingItemsFinal,
        currentStepIndex: 0,
        tower: getRoundTower({
          ...state,
          standardItems: onboardingItemsFinal,
        }),
        isAutoOnboarding,
        levelIndex,
      };
    }
    case REDUX_ACTIONS.NEXT_ONBOARDING_STEP: {
      const nextStepIndex = state.currentStepIndex + 1;

      return {
        ...state,
        currentStepIndex: nextStepIndex === state.standardItems.length ? null : nextStepIndex,
      };
    }
    case REDUX_ACTIONS.BUILD_ONBOARDING_TOWER: {
      return {
        ...state,
        tower: getRoundTower(state),
      };
    }
    default:
      return state;
  }
};

export default planTorresOnboardingRoundReducer;
